import { FormBuilderSection } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { InputConfig } from '../../../state/configuration'
import { isLoopConfig, isRepeaterConfig } from '../config'
import { INPUT_SECTION_CLASS } from '../options'
import { FormElement } from './FormElement'
import { FormHeader } from './FormHeader'
import { FormItemProps } from './FormItems'
import { InputLoop } from './InputLoop'
import { InputRepeater } from './InputRepeater'

export interface FormContentDynamicProps extends FormItemProps {
  item: InputConfig
}

export const FormContentDynamic: FunctionComponent<FormContentDynamicProps> = ({
  t,
  tKey,
  item,
  config,
  prefix,
  variant,
  errorClassName,
}) => {
  const { name, hidden } = item

  return hidden ? null : (
    <FormBuilderSection
      variant={variant}
      key={name}
      id={name}
      width={1}
      className={INPUT_SECTION_CLASS}
    >
      <FormHeader input={item} tKey={tKey} t={t} width={1} />

      {isLoopConfig(item) ? (
        <InputLoop
          t={t}
          tKey={tKey}
          item={item}
          config={config}
          errorClassName={errorClassName}
        />
      ) : isRepeaterConfig(item) ? (
        <InputRepeater
          item={item}
          config={config}
          t={t}
          tKey={tKey}
          errorClassName={errorClassName}
        />
      ) : (
        <FormElement
          t={t}
          tKey={tKey}
          item={item}
          config={config}
          prefix={prefix}
          errorClassName={errorClassName}
        />
      )}
    </FormBuilderSection>
  )
}
